import { useRef, useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAccountingsFiltered, selectElectricityFiltered } from "../store/selectors/supervisionSelector";
import { useMap } from "react-leaflet";
import L from 'leaflet'
import { addNotification } from "../store/reducers/notificationSlice";
import { addPulseMarker } from "./controls/helpers";

const types = {
    'pillar04': 'pillars',
    'pillar10': 'pillars',
    'pillar04_10': 'pillars',
    'pillar04-10': 'pillars',
    'pillar': 'pillars',
    'zvz': 'pillarsZvz',
    'opn': 'pillarsOpn',
    'rlnd': 'pillarsRlnd',
    'fider04': 'fiders',
    'fider10': 'fiders',
    'fider6': 'fiders',
    'fider10-04': 'fiders',
    'transformers': 'transformers',
    'transformer': 'transformers',
}

export const SetView = () => {
    const map = useMap()
    const [accountingBbox, setAccountingBbox] = useState('')
    const [mapBbox, setMapBbox] = useState('')
    const dispatch = useDispatch()
    const hasSetViewRef = useRef(false) // Ref для отслеживания, была ли уже установлена область для accountings
    const hasSetObjectViewRef = useRef(false) // Ref для отслеживания, была ли уже установлена область для объекта
    const isInfoNotificationShown = useRef(false)
    const isErrorNotificationShown = useRef(false)
    const accountingsFiltered = useSelector(selectAccountingsFiltered);
    const electricityFiltered = useSelector(selectElectricityFiltered);

    // Функция для проверки наличия параметра view в URL
    const hasViewParam = useCallback(() => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('view');
    }, []);

    // Функция для удаления параметра view из URL
    const removeViewParamFromUrl = useCallback(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('view')) {
            urlParams.delete('view');
            const newUrl = urlParams.toString()
                ? `${window.location.pathname}?${urlParams.toString()}`
                : window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    }, []);

    // Функция для расшифровки base64 сообщения из URL
    const decodeViewParam = useCallback(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const viewParam = urlParams.get('view');

        if (!viewParam) return null;

        try {
            // Декодируем base64
            const decoded = atob(decodeURIComponent(viewParam));
            // Парсим JSON
            const data = JSON.parse(decoded);
            return data;
        } catch (error) {
            console.error('Ошибка при расшифровке параметра view:', error);
            return null;
        }
    }, []);

    // Функция для установки обзора на конкретную опору
    const setObjectView = useCallback(() => {
        if (hasSetObjectViewRef.current) return;

        // Расшифровываем параметр view из URL
        const viewData = decodeViewParam();
        if (!viewData) {
            console.warn('Недостаточно данных для установки обзора:', viewData);
            return;
        }

        if (!electricityFiltered) {
            return;
        }

        const { type, id } = viewData;

        if (!id || !type) {
            console.warn('Недостаточно данных для установки обзора:', viewData);
            return;
        }

        console.log('Установка обзора на объект:', { type, id });

        // Включаем необходимые слои
        map.fire('overlaylayerchange', { name: type, state: true });

        // Функция для ожидания загрузки данных и установки обзора
        const waitForObjectAndSetView = () => {
            let object = null;

            console.log(types[type], electricityFiltered?.[types[type]])
            object = electricityFiltered?.[types[type]]?.find(t => Number(t.fid) === Number(id) || Number(t.id) === Number(id));

            if (object) {
                // Объект найден, устанавливаем обзор
                console.log('Объект найден, устанавливаем обзор:', object);
                map.setView([parseFloat(object.coords[0]), parseFloat(object.coords[1])], 18, { duration: 200, animate: false });
                setTimeout(() => {
                    map.eachLayer(function (layer) {
                        if (layer.options.data === id && layer.options.type === type) {
                            console.log(layer)
                            console.log('Устанавливаем обзор на объект:', object);
                            // Выводим слой на передний план
                            layer.setZIndexOffset(1000)
                            // Открываем попап
                            map.fire('openPopup', {
                                class: types[type],
                                mark: object,
                            });
                            setTimeout(() => {
                                addPulseMarker(map, layer);
                            }, 500);
                        }
                    });
                }, 1000);
                // Устанавливаем обзор на координаты объекта
                // setTimeout(() => {


                //     // Открываем попап объекта
                //     setTimeout(() => {
                //         map.fire('openPopup', {
                //             class: type === 'pillar' ? 'pillar' : 'transformer',
                //             mark: object,
                //         });
                //     }, 500);
                // }, 3000);

                hasSetObjectViewRef.current = true;
                // Удаляем параметр view из URL после успешной установки обзора
                removeViewParamFromUrl();
                return true;
            }

            return false;
        };

        // Данные загружены, пытаемся найти объект и установить обзор
        waitForObjectAndSetView()


    }, [map, electricityFiltered, decodeViewParam, removeViewParamFromUrl]);

    var calcAccountingBbox = useCallback(() => {
        // Если область уже была установлена, не делаем ничего
        if (hasSetViewRef.current) return;
        // Если есть параметр view в URL, не устанавливаем обзор на accountings
        if (hasViewParam()) return;

        let minx = 100;
        let maxx = 0;
        let miny = 100;
        let maxy = 0;
        if (accountingsFiltered && accountingsFiltered.length > 0) {
            accountingsFiltered.map(t => {
                const x = t.coords ? t.coords[0] : parseFloat(t.x_y_coord.split(' ')[1])
                const y = t.coords ? t.coords[1] : parseFloat(t.x_y_coord.split(' ')[0])
                minx = x < minx ? x : minx
                maxx = x > maxx ? x : maxx
                miny = y < miny ? y : miny
                maxy = y > maxy ? y : maxy
            })
        }

        if (minx !== 100) {
            setAccountingBbox([minx, miny, maxx, maxy].join(','))

        }
    }, [accountingsFiltered, hasViewParam])

    var calcMapBbox = useCallback(() => {
        // Если область уже была установлена, не делаем ничего
        if (hasSetViewRef.current) return;
        // Если есть параметр view в URL, не устанавливаем обзор на accountings
        if (hasViewParam()) return;

        let minx = 100;
        let maxx = 0;
        let miny = 100;
        let maxy = 0;
        if (electricityFiltered && electricityFiltered.transformers?.length > 0) {
            electricityFiltered.transformers.map(t => {
                const x = t.coords[0]
                const y = t.coords[1]
                minx = x < minx ? x : minx
                maxx = x > maxx ? x : maxx
                miny = y < miny ? y : miny
                maxy = y > maxy ? y : maxy
            })
        }

        if (minx !== 100) {
            setMapBbox([minx, miny, maxx, maxy].join(','))

        }
    }, [electricityFiltered, hasViewParam])

    useEffect(() => {
        // Проверяем, нужно ли установить обзор на конкретную опору
        // Вызываем только если есть параметр view в URL
        if (hasViewParam() && !hasSetObjectViewRef.current) {
            if (!isInfoNotificationShown.current) {
                dispatch(addNotification({
                    message: 'Установка обзора на объект...',
                    severity: 'info',
                    autoHideDuration: 10000
                }))
                isInfoNotificationShown.current = true
            }
            setTimeout(() => {
                if (!hasSetObjectViewRef.current && !isErrorNotificationShown.current) {
                    dispatch(addNotification({
                        message: 'Что-то пошло не так, удалите фильтры и попробуйте снова',
                        severity: 'error',
                        autoHideDuration: 10000
                    }))
                    isErrorNotificationShown.current = true
                }
            }, 10000)
            setObjectView();
        }
    }, [setObjectView, electricityFiltered, hasViewParam]);

    // useEffect(() => {
    //     // Устанавливаем обзор на accountings только если нет параметра view в URL
    //     if (!hasViewParam() && !hasSetViewRef.current && accountingsFiltered && accountingsFiltered.length > 0) {
    //         calcAccountingBbox()
    //     }
    // }, [accountingsFiltered, calcAccountingBbox, hasViewParam])

    useEffect(() => {
        // Устанавливаем обзор на accountings только если нет параметра view в URL
        if (!hasViewParam() && !hasSetViewRef.current && electricityFiltered && electricityFiltered.transformers?.length > 0) {
            calcMapBbox()
        }
    }, [electricityFiltered, calcMapBbox, hasViewParam])

    // useEffect(() => {
    //     if (!hasViewParam() && accountingBbox !== '' && !hasSetViewRef.current && !hasSetObjectViewRef.current) {
    //         map.fire('overlaylayerchange', { name: 'transformers', state: true })
    //         map.fire('overlaylayerchange', { name: 'pillar04', state: true })
    //         map.fire('overlaylayerchange', { name: 'fider04', state: true })
    //         map.fire('overlaylayerchange', { name: 'pillar10', state: true })
    //         map.fire('overlaylayerchange', { name: 'fider10', state: true })
    //         map.fire('overlaylayerchange', { name: 'pillar04_10', state: true })
    //         map.fire('overlaylayerchange', { name: 'fider04_10', state: true })

    //         const [minx, miny, maxx, maxy] = accountingBbox.split(',').map(t => parseFloat(t))
    //         setTimeout(() => {
    //             map.flyToBounds([[minx, miny], [maxx, maxy]], { maxZoom: 18, animate: false })
    //         }, 3000);
    //         hasSetViewRef.current = true // Отмечаем, что область была установлена
    //     }
    // }, [accountingBbox, map, hasViewParam])

    useEffect(() => {
        if (!hasViewParam() && mapBbox !== '' && !hasSetViewRef.current && !hasSetObjectViewRef.current) {
            // map.fire('overlaylayerchange', { name: 'transformers', state: true })
            // map.fire('overlaylayerchange', { name: 'pillar04', state: true })
            // map.fire('overlaylayerchange', { name: 'fider04', state: true })
            // map.fire('overlaylayerchange', { name: 'pillar10', state: true })
            // map.fire('overlaylayerchange', { name: 'fider10', state: true })
            // map.fire('overlaylayerchange', { name: 'pillar04_10', state: true })
            // map.fire('overlaylayerchange', { name: 'fider04_10', state: true })

            const [minx, miny, maxx, maxy] = mapBbox.split(',').map(t => parseFloat(t))
            setTimeout(() => {
                map.flyToBounds([[minx, miny], [maxx, maxy]], { maxZoom: 18, animate: false })
            }, 3000);
            hasSetViewRef.current = true // Отмечаем, что область была установлена
        }
    }, [mapBbox, map, hasViewParam])

    return null
}